import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    text: string;
};

export function CactusComingSoonPage(props: Props) {
    return (
        <EmptyStateSmall
            title=''
            subtitle={props.text}
            icon={
                <div style={{width: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
